/** Les appels audio et video. */
export const appels = {
  erreurs: {
    camera: "Sirocco n'a pas accès à ta caméra.",
    micro: "Sirocco n'a pas accès à ton micro.",
    connexion: "La connexion n'a pas pu s'établir. Réessaie depuis un autre réseau.",
    compteOfficiel: "Le compte de l'application ne prend pas d’appel. Écris-lui.",
    pasAmi: 'Tu ne peux appeler que tes amis. Ajoute ce membre d’abord.',
    pasAbouti: "L'appel n'a pas pu aboutir.",
    nExistePlus: "Cet appel n'existe plus.",
  },
  natif: {
    pasAbouti: "L'appel n'a pas pu aboutir.",
  },
  ecran: {
    quelquun: 'Quelqu’un',
    personneNaRepondu: 'Personne n’a répondu.',
    pasParti: "L'appel n'a pas pu partir.",
    pasAbouti: "L'appel n'a pas pu aboutir.",
    echanger: 'Échanger les deux images',
    reduire: 'Réduire l’appel',
    appel: 'Appel',
    connexion: 'Connexion…',
    appelVideo: 'Appel vidéo…',
    appelEnCours: 'Appel…',
    refuser: 'Refuser',
    repondreVideo: 'Répondre en vidéo',
    repondre: 'Répondre',
    accepter: 'Accepter',
    reactiverMicro: 'Réactiver le micro',
    couperMicro: 'Couper le micro',
    montrerCamera: 'Montrer ma caméra',
    cameraPasOuverte: "La caméra n'a pas pu s'ouvrir.",
    rallumerCamera: 'Rallumer ma caméra',
    couperCamera: 'Couper ma caméra',
    ecouteur: 'Revenir à l’écouteur',
    hautParleur: 'Passer sur le haut-parleur',
    raccrocher: 'Raccrocher',
    entrant: { video: 'Appel vidéo…', audio: 'Appel audio…' },
    son: (detail: string) => `Son : ${detail}`,
    natifMuet: 'le natif ne répond pas',
  },
};
